import { Input }          from "@mantine/core";
import { useTranslation } from "react-i18next";

import Icon      from "_components/atoms/icon";
import useStyles from "_styles/atoms/inputFieldVideos";

const component = props => {
	const {
		commentInput,
		handleOnChange,
		showEmojiIcon = true,
		handleToggleEmoji,
		displayEmoji,
		textInput,
		focusState,
		toggleFocusState,
		from,
		throttledCommentToPost,
		handleSendClick
	} = props;

	const { classes } = useStyles ( { displayEmoji, commentInput, from } );
	const { t }       = useTranslation ();

	const focusInputState = displayEmoji || focusState ? true : false;

	return (
		<div className = { `${ classes.commentInputContainerDiv }` }>
			{showEmojiIcon ? (
				<Icon
					className = { classes.emojiIcon }
					name      = "emoji"
					onClick   = { () => handleToggleEmoji () }
				/>
			) : null}

			<Input
				ref                       = { textInput }
				fullWidth
				autoComplete              = "off"
				classNames                = { {
					input   : classes.commentRootContainer,
					wrapper : classes.commentInput

				} }
				focused                   = { focusInputState }
				id                        = "commentInput"
				inputRef                  = { textInput }
				onBlur                    = { () => textInput?.current?.blur () }
				onChange                  = { handleOnChange }
				onFocus                   = { toggleFocusState }
				onKeyDown                 = { throttledCommentToPost }
				placeholder               = { t ( "comment_field_what_do_you_think" ) }
				rightSection              = { (
					<Icon
						sameInBothTheme
						className = { `${ classes.icon } ${ classes.sendIconStyles }` }
						name      = "send"
						onClick   = { handleSendClick }
					/>
				) }
				rightSectionPointerEvents = "all"
				rightSectionWidth         = { 110 }
				value                     = { commentInput }
				variant                   = "outline"

			/>
		</div>
	);
};

export default component;
